import moment from 'moment';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Button, Card, CardBody, Col, Container, Row } from 'reactstrap';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import TableContainer from '../../../Components/Common/TableContainer';
import { PageHeader } from '../../../Components/Custom/PageHeader';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { dateForExport, setDocumentTitle } from '../../../helpers/helpers';
import { columns } from './columns';
import {
  exportHeaders,
  exportTeamBonus,
  getTeamBonus,
  removeTeamBonusForExport,
  paramsForExport
} from './slice';

import { Filters } from './filters';
import { CsvExport } from '../../../Components/Custom/CsvExport';
import { Pagination } from '../../../Components/Custom/pagination';

const PAGE_TITLE = 'Team Bonus';

const INITIAL_PARAMS: {
  sortBy: string;
  sortOrder: string;
  countPerPage: string;
  numberOfPage: string;
} = {
  sortBy: 'dateCreated',
  sortOrder: 'DESC',
  countPerPage: '10',
  numberOfPage: '1'
};

const TeamBonusPage = () => {
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams(INITIAL_PARAMS);
  const { loading, loadingExport, data, dataForExport, totalCount } =
    useAppSelector((state) => state.teamBonus);

  setDocumentTitle(PAGE_TITLE);

  useEffect(() => {
    dispatch(getTeamBonus(searchParams));
  }, [searchParams]);

  return (
    <div className='page-content'>
      <Container fluid>
        <BreadCrumb title={PAGE_TITLE} pageTitle='Bonuses' />
        <Row>
          <Col lg={12}>
            <Card id='orderList'>
              <PageHeader
                loading={loading || loadingExport}
                initialParams={INITIAL_PARAMS}
                setSearchParams={setSearchParams}
                title={PAGE_TITLE}
                actions={
                  <>
                    <CsvExport
                      action={() =>
                        dispatch(exportTeamBonus(paramsForExport(searchParams)))
                      }
                      data={dataForExport}
                      headers={exportHeaders}
                      disabled={loading || loadingExport}
                      fileName={`teamBonus-${dateForExport}`}
                      removeDataAction={removeTeamBonusForExport}
                      buttonName='Export filtered data'
                    />
                  </>
                }
              />
              <CardBody className='pt-0'>
                <Filters
                  params={searchParams}
                  setParams={setSearchParams}
                  initialParams={INITIAL_PARAMS}
                />

                <TableContainer
                  columns={columns}
                  data={data.userTeamBonuses || []}
                  divClass='table-responsive table-card mb-1'
                  tableClass='align-middle table-nowrap'
                  theadClass='table-light text-muted'
                />

                <Pagination
                  totalCount={totalCount}
                  data={data?.userTeamBonuses}
                  params={searchParams}
                  setParams={setSearchParams}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TeamBonusPage;
